var render, staticRenderFns
import script from "./MenuLayoutMenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuLayoutMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayoutMenuItem.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports